import React from "react";
import RefreshIcon from "@material-ui/icons/Refresh";
import { Tooltip, CircularProgress } from "@material-ui/core";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixFooterProps } from "../types";

const PixFooter: React.FC<PixFooterProps> = ({
  paymentStatus,
  onClose,
  onRefreshQrCode,
  refreshing,
}) => {
  const classes = usePixModalStyles();
  const isPending = paymentStatus === "pending";

  return (
    <div className={classes.footer}>
      {isPending && onRefreshQrCode && (
        <Tooltip title="Atualiza o QR Code com dados mais recentes">
          <button
            className={classes.btnSecondary}
            onClick={onRefreshQrCode}
            disabled={refreshing}
            aria-label="Atualizar QR Code"
          >
            {refreshing ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              <RefreshIcon style={{ fontSize: 16 }} />
            )}
            {refreshing ? "Atualizando..." : "Atualizar QR Code"}
          </button>
        </Tooltip>
      )}
      <button
        className={`${classes.btnOutline} ${classes.btnOutlineRed}`}
        onClick={onClose}
      >
        Fechar
      </button>
    </div>
  );
};

export default PixFooter;
